import React from "react";
import { useState } from "react";
import "../Style/style.css";
const friday = [
  {
    one: "12:45-13:00",
    two: "Opening Remarks",
    three: "Course Directors",
  },
  {
    one: "13:00-13:30",
    two: "Physics of 3D Imaging ",
    three: "Feroze Mahmood",
  },
  {
    one: "13:30-14:00",
    two: "Transducer Design ",
    three: "Aidan Sharkey",
  },
  {
    one: "14:00-14:30",
    two: "Frame Rate, Line Density, Sector Size",
    three: "Mario Gallegos",
  },
  {
    one: "14:30-15:00",
    two: "Terminology of 3D Imaging",
    three: "Feroze Mahmood ",
  },
  {
    one: "15:00-15:15",
    two: "Afternoon Break",
    isBreak: true,
  },
  {
    one: "15:15-15:45",
    two: "Knobology and Physics",
    three: "Feroze Mahmood",
  },
  {
    one: "15:45-16:15",
    two: "Introduction to Multiplanar Reconstruction",
    three: "Aidan Sharkey",
  },
  {
    one: "16:15-16:45",
    two: "Clinical Application of Multiplanar Reconstruction",
    three: "Sohail K. Mahboobi",
  },
  {
    one: "16:45-17:00",
    two: "Pose Your Questions to the Experts ",
    three: "",
  },
];
const saturday = [
  {
    one: "7:00-7:05",
    two: "Introduction",
    three: "Feroze Mahmood",
  },
  {
    one: "7:05-7:30",
    two: "Overview of Structural Heart Disease",
    three: "Feroze Mahmood",
  },
  {
    one: "7:30-7:45",
    two: "Hybrid Operating Room Setup",
    three: "Ruma Bose",
  },
  {
    one: "7:45-8:00",
    two: "Radiation Safety",
    three: "Anastasia Katsiampour",
  },
  {
    one: "8:00-8:25",
    two: "Fluoroscopic Imaging",
    three: "Kendra Derry",
  },
  {
    one: "8:25-8:50",
    two: "Heart Team Model",
    three: "Charles Nyman, Douglas Shook and Burkhard Mackensen",
  },
  {
    one: "8:50-9:20",
    two: "Panel Discussion: Billing and staffing for Structural Heart Disease",
    three: "Feroze Mahmood, Douglas Shook, Stanton Shernan, Burkhard Mackensen and Micheal Haering",
  },
  {
    one: "9:20-9:35",
    two: "Pose Your Questions to the Experts",
    three: "Feroze Mahmood, Douglas Shook, Stanton Shernan Burkhard Mackensen and Micheal Haering",
  },
  {
    one: "9:35-9:45",
    two: "MORNING BREAK",
    three: "",
    isBreak: true,

  },
  {
    one: "9:45-9:50",
    two: "Introduction",
    three: "Ruma Bose",
  },
  {
    one: "9:50-10:20",
    two: "Virtual Live Dissection",
    three: "Douglas Shook",
  },
  {
    one: "10:20-10:45",
    two: "Nomenclature of Interatrial Septum",
    three: "Feroze Mahmood",
  },
  {
    one: "10:45-11:10",
    two: "Transesophageal Echocardiography for Transseptal Puncture",
    three: "Aidan Sharkey",
  },
  {
    one: "11:10-11:40",
    two: "Needles and Equipment for Transseptal Puncture",
    three: "Bharath Rathakrishnan",
  },{
    one: "11:40-12:00",
    two: "Case Discussion",
    three: "Ruma Bose",
  },
  {
    one: "12:00-1:00",
    two: "LUNCH BREAK",
    isBreak: true,
    three: "",
  },
  {
    one: "1:00-1:05",
    two: "Introduction",
    three: "Feroze Mahmood",
  },
  {
    one: "1:05-1:35",
    two: "3D Anatomy of Mitral Valve",
    three: "Stanton Shernan",
  },
  {
    one: "1:35-2:05",
    two: "Mitral Valve Anatomy for Degenerative Edge-to-edge Repair",
    three: "Burkhard Mackensen",
  },
  {
    one: "2:05-2:35",
    two: "Mitral Valve Anatomy for Functional Mitral Regurgitation",
    three: "Andrew Maslow",
  },
  {
    one: "2:35-3:00",
    two: "Panel Discussion",
    three: "Stanton Shernan",
  },
  {
    one: "3:00-3:15",
    two: "Case Discussion",
    three: "",
  },
  {
    one: "3:15-3:20",
    two: "Introduction",
    three: "Andrew Maslow",
  },
  {
    one: "3:20-3:45",
    two: "Mitral Regurgitation Assessment",
    three: "Aidan Sharkey",
  },
  {
    one: "3:45-4:10",
    two: "Edge-to-edge repair in Degenerative MR - Case Presentation",
    three: "Sohail Mahboobi",
  },
  {
    one: "4:10-4:35",
    two: "Functional Mitral Regurgitation - Case Presentation",
    three: "Charles Nyman",
  },
  {
    one: "4:35-5:00",
    two: "Post Edge-to-edge Repair Assessment",
    three: "Shweta Yemul Golhar",
  },
  {
    one: "5:00-5:30",
    two: "Case Discussion",
    three: "Andrew Maslow",
  },
  {
    one: "5:30-5:45",
    two: "Pose Your Questions to the Experts",
    three: "",
  },
 
];

const sunday = [
  {
    one: "7:00-7:05",
    two: "Introduction to Left Atrial Appendage Session",
    three: "Daniel McGrail",
  },
  {
    one: "7:05-7:30",
    two: "Left Atrial Appendage Anatomy and Function",
    three: "Mark Robitaille",
  },
  {
    one: "7:30-7:55",
    two: "Left Atrial Appendage Sizing",
    three: "Anastasia Katsiampoura",
  },
  {
    one: "7:55-8:20",
    two: "Echocardiographic Guidance for Left Atrial Appendage Occlusion",
    three: "Kendra Derry",
  },
  {
    one: "8:20-8:45",
    two: "Different Types of Devices for Left Atrial Appendage Occlusion",
    three: "Marie France Pouline",
  },
  {
    one: "8:45-9:20",
    two: "Case Discussion",
    three: "Daniel McGrail",
  },
  {
    one: "9:20-9:30",
    two: "Pose Your Questions to the Experts",
    three: "",
  },
  {
    one: "9:30-9:45",
    two: "MORNING BREAK",
    isBreak: true,
    three: "",
  },
  {
    one: "9:45-9:50",
    two: "Introduction",
    three: "Sohail Mahboobi",
  },
  {
    one: "9:50-10:15",
    two: "Mitral Valve In-valve Therapy: Case Presentation",
    three: "Daniel McGrail",
  },
  {
    one: "10:15-10:40",
    two: "Mitral Paravalvular Leak",
    three: "Faraz Mahmood",
  },
  {
    one: "10:40-11:05",
    two: "Aortic Paravalvular Leak",
    three: "Sankalp Sehgal",
  },{
    one: "11:05-11:30",
    two: "LAMPOON Procedure",
    three: "Burkhard Mackensen",
  },
  {
    one: "11:30-11:55",
    two: "TEE Guidance for ASD Closure Devices",
    three: "Sohail Mahboobi",
  },
  {
    one: "11:55-12:10",
    two: "Case-Based Discussion",
    three: "Sohail Mahboobi",
  },
  {
    one: "12:10-12:30",
    two: "Pose Your Questions to the Experts",
    three: "Faculty",
  },
  {
    one: "12:30-1:30",
    two: "LUNCH BREAK",
    isBreak: true,
    three: "",
  },
  {
    one: "1:30-1:35",
    two: "Introduction",
    three: "",
  },
  {
    one: "1:35-2:00",
    two: "Tricuspid Valve 3D Examination",
    three: "Kendra Derry, MD",
  },
  {
    one: "2:00-2:25",
    two: "Workflow of Tricuspid Valve Edge-to-edge Repair",
    three: "Sohail Mahboobi, MD",
  },{
    one: "2:25-2:50",
    two: "Percutaneous Tricuspid Valve Replacement",
    three: "Faraz Mahmood, MD",
  },
  {
    one: "2:50-3:45",
    two: "Case Discussion",
    three: "Sankalp Sehgal, MD",
  },
  {
    one: "3:45-4:00",
    two: "EVENING BREAK",
    isBreak: true,
    three: "Kendra Derry, MD",
  },
  {
    one: "4:00-4:05",
    two: "Introduction",
    three: "Aidan Sharkey",
  },
  {
    one: "4:05-4:35",
    two: "Training for Structural Heart Disease Imaging",
    three: "Ruma Bose",
  },
  {
    one: "4:35-5:05",
    two: "Fucture Direction of SHD Interventions and New Therapies",
    three: "Feroze Mahmood",
  },
  {
    one: "5:05-5:15",
    two: "Pose Your Questions to the Experts",
    three: "",
  },
  {
    one: "5:15-5:30",
    two: "CONCLUDING REMARKS",
    three: "",
  },
 
];

const Schedule = () => {
  const [selectedDay, setSelectedDay] = useState("friday");
  const handle = (selected) => {
    setSelectedDay(selected);
  };
  const dayData = { friday, saturday, sunday };
  const activeStyle = { backgroundColor: "#ae2a2f", color: "white", fontWeight: "bold" };
  const inactiveStyle = { backgroundColor: "white", color: "#ae2a2f", fontWeight: "bold" };
  return (
    <section id="resume" className="section schedule-section">
      <div className="container">
        {/* Sechedule */}
        <h2 className="text-10 fw-600 mb-4 text-center" style={{ color: "white" }}>
          Course Schedule
        </h2>
        <div className="d-flex justify-content-center gap-5">
          <div
            className="timeDate"
            onClick={() => handle("friday")}
            style={selectedDay === "friday" ? activeStyle : inactiveStyle}
          >
            Friday
          </div>
          <div
            className="timeDate"
            onClick={() => handle("saturday")}
            style={selectedDay === "saturday" ? activeStyle : inactiveStyle}
          >
            Saturday
          </div>
          <div
            className="timeDate"
            onClick={() => handle("sunday")}
            style={selectedDay === "sunday" ? activeStyle : inactiveStyle}
          >
            Sunday
          </div>
        </div>
        <div className="container mt-5">
  <div className="row">
    {dayData[selectedDay].map((day, index) => {
      if (day.isBreak === true) {
        return (
          <div
            key={`break-${index}`}
            className="col-lg-6 offset-lg-3 rounded border bg-white mt-2"
            style={{ color: "#ae2a2f !important" }}
          >
            <div className="row">
              <div className="col-sm-4 customColumn scheduleCard">
                <span className="">{day.one}</span>
              </div>
              <div className="col-sm-4 customColumn scheduleCard">
                {day.two}
              </div>
              <div className="col-sm-4 customColumn scheduleCard"></div>
            </div>
          </div>
        );
      } else {
        return (
          <div
            key={`event-${index}`}
            className="col-lg-6 offset-lg-3 rounded text-white border bg-danger mt-2"
          >
            <div className="row">
              <div className="col-sm-4 customColumn scheduleCard">
                <span className="">{day.one}</span>
              </div>
              <div className="col-sm-4 customColumn scheduleCard">
                {day.two}
              </div>
              <div className="col-sm-4  customColumn scheduleCard">
                {day.three}
              </div>
            </div>
          </div>
        );
      }
    })}
  </div>
</div>

      </div>
    </section>
  );
};

export default Schedule;
